
import mobile from "../assets/svg/skills/mobile.jfif"
export const achievementData = {
  bio: "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
  achievements: [
    {
      id: 1,
      title: "Mobile Application Development",
      details:
        "Flutter and Django Certification from Jawan Pakistan , included frontend and backend both",
      date: "March 20, 2022",
      field: "App Development",
      image:
        "https://www.vaival.com/wp-content/uploads/2021/01/vaival-application.png",
    },
    {
      id: 2,
      title: "Freelance Workshop Certification",
      details:
        "Validate technical skills and cloud expertise to grow your career and business.",
      date: "Nov 18, 2021",
      field: "Automation",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRchYU8Qr5yujaIY5pCNItVbjwZp860ybpK2EVjk4CaJOlc-3J7WQG1mO_KKzrp_c74J4I&usqp=CAU",
    },
    {
      id: 3,
      title: "Good Core Certification",
      details:
        "Participating in Mobile App Development Competition held in NEDUET",
      date: "Aug 20, 2019",
      field: "Automation",
      image:
        "https://www.digitalmarketingcommunity.com/wp-content/uploads/2020/03/GoodCore.png",
    },
  ],
};


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/